// Modal1.tsx
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useState } from 'react';
import { useAuth } from '../../../auth';
import { useAppSelector } from '../../../../../redux/hooks';
import axios from 'axios';
import { useEffect } from 'react';
import { getInstances, getInstancesGlobales } from '../../Dashboard/requests/request';
import Swal from 'sweetalert2';
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo';
import { useAppDispatch } from '../../../../../redux/hooks';
import { SetInstance } from '../../../../../redux/feature/InstanceSlice';
import { SetvRF } from '../../../../../redux/feature/VrfSlice';
import { SetConnector } from '../../../../../redux/feature/ConnectorSlice';

const API_URL = process.env.REACT_APP_API_URL

type connector = {
  id: string,
  name: string
}

interface Modal1Props {
  showModal: boolean;
  handleClose: () => void;
  setDatos: any

}


type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}


type ID = undefined | null | number

const Modal1: React.FC<Modal1Props> = ({ showModal, handleClose, setDatos }) => {
  const [ID, setID] = useState<ID>(undefined)
  const Instance = useAppSelector(state => state.InstanceSlice.id);
  const VRF = useAppSelector(state => state.VrfSlice.id)
  const connector = useAppSelector(state => state.ConnectorSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)

  const dispatch = useAppDispatch();
  /////////////////////////////////////////
  const [name, setname] = useState('')
  const [localSubnet, setlocalSubnet] = useState('')
  const [remoteSubnet, setremoteSubnet] = useState('')




  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const { currentUser } = useAuth()
  //const [vrfselect,setselectvrf]= useState<any>()
  const [listvrf, setlistvrff] = useState<vrf[]>([])
  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''

  }])
  //const[Busqueda,setBusqueda]= useState("")
  const [configApplied, setConfigApplied] = useState(false);




  useEffect(() => {
    const fetchData = async () => {
      try {
        if (FlagReg === true) {
          if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
            if (tenant === 0) {
              const instancias = await getInstances(Id, 'Ctx.IPSEC.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {
                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }


              }
            }
            else {
              const instancias = await getInstancesGlobales(Id, tenant, 'Ctx.IPSEC.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {

                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }

              }
            }
          }
          else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
            if (tenant === 0) {
              const instancias = await getInstances(Id, 'Ctx.IPSEC.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {
                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }


              }
            }
            else {
              const instancias = await getInstancesGlobales(Id, tenant, 'Ctx.IPSEC.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {

                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }

              }
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [FlagReg, nameregion]
  )
  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '') {
          const body =
          {
            instanceId: Number(Instance),
            suscriptionId: Id
          }
          if (tenant !== 0) {
            await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }

          else if (tenant === 0) {
            await axios.post(API_URL + '/v1/listVrf', body)
              .then(res => {
                setlistvrff(res.data)
              })
          }

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Instance, Id])

  const [listConnector, setlisConnector] = useState<connector[]>([])


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '' && VRF !== undefined && VRF !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[Number(VRF)]

          if (tenant !== 0) {
            await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector?tenantId=' + tenant)
              .then(res => {
                setlisConnector(res.data)
              })
          }

          else if (tenant === 0) {
            await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector')
              .then(res => {
                setlisConnector(res.data)
              })
          }

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [VRF])

  ///////////////////////////////////////////////////GLOBAL////////////////////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
          if (tenant === 0) {
            const instancias = await getInstances(-1, 'Ctx.IPSEC.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {
              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }
            }
          }
          else {
            const instancias = await getInstancesGlobales(-1, tenant, 'Ctx.IPSEC.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {
              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }
            }
          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, Type]
  )
  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Type === 'CloudGlobal' && Instance !== '') {

          const body =
          {
            instanceId: Number(Instance),
            suscriptionId: '-1'
          }
          await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
            .then(res => {
              setlistvrff(res.data)
            })

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Instance, Id, Type])
  ////////////////////////////
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Instance !== '' && VRF !== undefined && VRF !== '' && Type === 'Global') {
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[Number(VRF)]

          await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector?tenantId=' + tenant)
            .then(res => {
              setlisConnector(res.data)
            })

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Id, VRF])

  /*********************************************SE REALIZA POST PARA AGREGAR PREFIX LIST*********************** */
  const [del, setdel] = useState(false)
  const [swalInput, setSwalInput] = useState('');

  useEffect(() => {
    if (configApplied) {
      handleClose(); // Cierra el modal automáticamente
    }
  }, [configApplied]);

  const ADDSegment = async () => {
    if (VRF === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Please Select a VRF',
      });
      return; // Detener la ejecución si la VRF no está seleccionada
    }
    if (!connector) {
      Swal.fire({
        icon: 'warning',
        title: 'Please Select a Connector',
      });
      return; // Detener la ejecución si el conector no está seleccionado
    }
    if (name === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Please add your policy name',
      });
      return; // Detener la ejecución si el conector no está seleccionado
    }
    if (localSubnet === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Please add Local Subnet',
      });
      return; // Detener la ejecución si el conector no está seleccionado
    }
    if (remoteSubnet === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Please add Remote Subnet',
      });
      return; // Detener la ejecución si el conector no está seleccionado
    }
    if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '' && name !== '' && localSubnet !== '' && remoteSubnet !== '' && currentUser?.ListPermiso?.includes('Ctx.BGP.Add')) {
      try {

        const vrf = listvrf[Number(VRF)]


        const body = {
          vrf: vrf,
          policy: {
            name: name,
            localSubnet: localSubnet,
            remoteSubnet: remoteSubnet,
            //action:action,
            //mode:mode,
            //Priority:Priority
          }
        }
        console.log(body)

        Swal.fire({
          width: '40%',
          position: 'center',
          icon: 'warning',
          title: "Are you sure you want to apply this configuration?",
          html: ` <p>
                <strong>¡Attention!</strong> You are about to apply new configuration settings. Please verify that the following policy is correct:</p>
                <strong style="color: red">This process may take a few seconds, please wait.</strong>
                <br/>
                <br/>
                <pre>Name:${name}</pre>
                <pre>Local-ts Subnet:${localSubnet}</pre>
                <pre>Remote-ts Subnet:${remoteSubnet}</pre>            
                `,
          input: 'text',
          inputLabel: 'Enter "confirm" to continue...',
          inputValue: swalInput,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Add!',
          preConfirm: (value) => {
            if (!value.toLowerCase().includes('confirm')) {
              Swal.showValidationMessage('The input must contain the word "confirm"');
            } else {
              setSwalInput(value);
            }
          },
        })
          .then((result) => {

            if (result.isConfirmed) {
              setSwalInput('');

              setdel(true)
              if (tenant === 0) {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/add_one_phase_two/' + connector, body).then(res => {
                  setConfigApplied(true);
                  /********************************************************************** */

                  if (res.data && res.data.length !== 0) {

                    // Si hay datos, pero también hay errores, mostrar un mensaje combinado
                    if (res.data.error && res.data.error.length !== 0) {
                      Swal.fire({
                        icon: 'warning',
                        title: 'Security policy already exists',
                        html: `<p>The security policy you are trying to add already exists.</p>
                                   <p>Please review your configurations and try again.</p>
                         `
                      });
                      setdel(false);
                    } else {
                      // Solo hay datos, mostrar el mensaje de éxito
                      Swal.fire(
                        'Added!',
                        'Your Policy have been Added.',
                        'success'
                      );
                      setdel(false);
                      setDatos(res.data);
                    }
                  }
                  else if (res.data.error && res.data.error === 'security policy already exists') {

                    // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
                    Swal.fire({
                      icon: 'warning',
                      title: 'Security policy already exists',
                      html: `<p>The security policy you are trying to add already exists.</p>
                                 <p>Please review your configurations and try again.</p>`
                    });
                    setdel(false);

                  }
                  /************************************************************************* */
                });
              }
              else {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/add_one_phase_two/' + connector + '?tenantId=' + tenant, body).then(res => {
                  setConfigApplied(true);
                  /********************************************************************** */
                  if (res.data && res.data.length !== 0) {

                    // Si hay datos, pero también hay errores, mostrar un mensaje combinado
                    if (res.data.error && res.data.error.length !== 0) {

                      Swal.fire({
                        icon: 'warning',
                        title: 'Security policy already exists',
                        html: `<p>The security policy you are trying to add already exists.</p>
                                       <p>Please review your configurations and try again.</p>`
                      });
                      setdel(false);
                    } else {
                      // Solo hay datos, mostrar el mensaje de éxito

                      Swal.fire(
                        'Added!',
                        'Your Policy have been Added.',
                        'success'
                      );
                      setdel(false);
                      setDatos(res.data);
                    }
                  }

                  else if (res.data.error === 'security policy already exists') {

                    // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
                    Swal.fire({
                      icon: 'warning',
                      title: 'Security policy already exists',
                      html: `<p>The security policy you are trying to add already exists.</p>
                                     <p>Please review your configurations and try again.</p>`
                    });
                    setdel(false);

                  }
                  /************************************************************************* */
                });
              }
            } else {
              Swal.fire({ title: "The configuration has not been applied!", icon: "info" });
            }
          });
        // Realiza la primera solicitud axios 
      }
      catch (error: any) {
        console.log(error)

      }
    }
  }



  const ADDSegmentGlobal = async () => {
    if (Instance !== '' && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.Add')) {
      try {

        const vrf = listvrf[Number(VRF)]

        const body = {
          vrf: vrf,
          policy: {
            name: name,
            localSubnet: localSubnet,
            remoteSubnet: remoteSubnet,

            // action:action,
            // mode:mode,
            //Priority:Priority
          }
        }


        //Se pregunta si se quiere aplicar la config 
        Swal.fire({
          width: '40%',
          position: 'center',
          icon: 'warning',
          title: "Are you sure you want to apply this configuration?",
          text: "If you send incorrect data, there's a risk of losing connectivity.",
          html: ` <p>
                  <strong>¡Attention!</strong> You are about to apply new configuration settings. Please verify that the following Security Policy:</p>
                  <pre>Name:${name}</pre>
                  <pre>Local-ts Subnet:${localSubnet}</pre>
                  <pre>Remote-ts Subnet:${remoteSubnet}</pre>            
                  
                  `,
          input: 'text',
          inputLabel: 'Enter "confirm" to continue...',
          inputValue: swalInput,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Add!',
          preConfirm: (value) => {
            if (!value.toLowerCase().includes('confirm')) {
              Swal.showValidationMessage('The input must contain the word "confirm"');
            } else {
              setSwalInput(value);
            }
          },
        })
          .then((result) => {

            if (result.isConfirmed) {
              setdel(true)
              setSwalInput('');

              if (tenant === 0) {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/add_one_phase_two/' + connector, body).then(res => {
                  setConfigApplied(true);
                  if (res.data && res.data.length !== 0) {

                    // Si hay datos, pero también hay errores, mostrar un mensaje combinado
                    if (res.data.error && res.data.error.length !== 0) {
                      Swal.fire({
                        icon: 'warning',
                        title: 'Security policy already exists',
                        html: `<p>The security policy you are trying to add already exists.</p>
                                     <p>Please review your configurations and try again.</p>
                           `
                      });
                      setdel(false);
                    } else {
                      // Solo hay datos, mostrar el mensaje de éxito
                      Swal.fire(
                        'Added!',
                        'Your Policy have been Added.',
                        'success'
                      );
                      setdel(false);
                      setDatos(res.data);
                    }
                  }
                  else if (res.data.error && res.data.error === 'security policy already exists') {

                    // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
                    Swal.fire({
                      icon: 'warning',
                      title: 'Security policy already exists',
                      html: `<p>The security policy you are trying to add already exists.</p>
                                   <p>Please review your configurations and try again.</p>`
                    });
                    setdel(false);

                  }
                });
              }
              else {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/add_one_phase_two/' + connector + '?tenantId=' + tenant, body).then(res => {
                  setConfigApplied(true);
                  if (res.data && res.data.length !== 0) {

                    // Si hay datos, pero también hay errores, mostrar un mensaje combinado
                    if (res.data.error && res.data.error.length !== 0) {

                      Swal.fire({
                        icon: 'warning',
                        title: 'Security policy already exists',
                        html: `<p>The security policy you are trying to add already exists.</p>
                                     <p>Please review your configurations and try again.</p>`
                      });
                      setdel(false);
                    } else {
                      // Solo hay datos, mostrar el mensaje de éxito

                      Swal.fire(
                        'Added!',
                        'Your Policy have been Added.',
                        'success'
                      );
                      setdel(false);
                      setDatos(res.data);
                    }
                  }

                  else if (res.data.error === 'security policy already exists') {

                    // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
                    Swal.fire({
                      icon: 'warning',
                      title: 'Security policy already exists',
                      html: `<p>The security policy you are trying to add already exists.</p>
                                   <p>Please review your configurations and try again.</p>`
                    });
                    setdel(false);

                  }


                });
              }
            } else {
              Swal.fire({ title: "The configuration has not been applied!", icon: "info" });
            }
          });

        // Realiza la primera solicitud axios
        // Cierra el SweetAlert después de completar las solicitudes
        //Swal.close();
      }
      catch (error: any) {
        console.log(error)

      }

    }
  }

  useEffect(() => {
    return () => {
      setConfigApplied(false); // Restablece configApplied cuando el componente se desmonta
    };
  }, [configApplied]);



  useEffect(() => {
    if (Instance) {
      dispatch(SetvRF(''))
      dispatch(SetConnector(''))
      setname('')
      setlocalSubnet('')
      setremoteSubnet('')
    }
  }, [Instance])

  useEffect(() => {
    if (VRF) {
      dispatch(SetConnector(''))
      setname('')
      setlocalSubnet('')
      setremoteSubnet('')
    }
  }, [VRF])

  useEffect(() => {
    if (!showModal) {
      setname('')
      setlocalSubnet('')
      setremoteSubnet('')
    }
  }, [showModal])



  return (
    <>
      <div>
        <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex={-1} aria-labelledby="exampleModalLabel1" aria-hidden={!showModal}>
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel1"></h5>
                <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {/* Contenido específico para Modal 1 */}
                <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Add IPSec Segment</h1>
                <br />
                <label className='form-label f-bold fs-p text-marino  required form-label' >Instance</label>
                <select className="form-select border-gray-300 f-parrafo fs-p text-dk text-center " aria-label="Select example"
                  onChange={e => dispatch(SetInstance(Number(e.target.value)))} value={Instance}>
                  <option disabled selected hidden defaultValue={0}>Select an Instance </option>
                  {Instancia.length === 0 && <option disabled selected hidden>No data</option>}
                  {Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                  {Type === 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                </select>
                <div className="row">
                  <div className='col'>
                    <label className='form-label  text-marino  required form-label' >VRF</label>
                    <select className="form-select border-gray-300 f-parrafo  text-dk text-center w-200px" aria-label="Select example"
                      onChange={e => dispatch(SetvRF(Number(e.target.value)))} value={VRF}>
                      {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                      {Instance !== '' && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                        <>
                          {!vrf.vrf && <option key={i} value={i}>Main</option>}
                          {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                        </>
                      )
                      }

                      {Instance !== '' && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                        <>
                          {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                          {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                        </>
                      )
                      }
                    </select>
                  </div>
                  <div className='col'>
                    <label className='form-label  text-marino  required form-label' >Connector</label>
                    <select className="form-select border-gray-300 f-parrafo  text-dk text-center w-200px" aria-label="Select example"
                      onChange={e => dispatch(SetConnector(e.target.value))} value={connector}>

                      {listConnector?.length === 0 ? <option key={'c'} className='text-danger bg-info' hidden>No Connector</option> : <option hidden>Select an Connector </option>}

                      {Instance !== '' && Id !== 0 && Id !== -1 && listConnector.length !== 0 && listConnector?.map((con: any, i: any) =>
                        <>
                          {con.name !== '' && <option key={i} value={con.id}>{con.name}</option>}
                        </>
                      )
                      }

                      {Instance !== '' && Type === 'CloudGlobal' && listConnector.length !== 0 && listConnector?.map((con: any, i) =>
                        <>
                          {con.name !== '' && <option key={i} value={con.id}>{con.name}</option>}

                        </>
                      )
                      }
                    </select>
                  </div>
                </div>
                <br />
                {/* Campos solicitud */}
                <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Security Policy Name</label>
                <input
                  required
                  type="text"
                  className="form-control form-control-solid border-gray-300 f-parrafo "
                  placeholder=""
                  id='Resumen'
                  value={name}
                  onChange={(e: any) => setname(e.target.value)}
                  maxLength={150}

                />

                <br />

                <div className='row'>
                  <div className='col'>
                    <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Local-ts Subnet</label>
                    <input
                      required
                      type="text"
                      className="form-control form-control-solid border-gray-300 f-parrafo "
                      placeholder=""
                      id='local-sub'
                      value={localSubnet}
                      onChange={(e: any) => setlocalSubnet(e.target.value)}
                      maxLength={150}

                    />
                  </div>
                  <div className='col'>
                    <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Remote-ts Subnet</label>
                    <input
                      required
                      type="text"
                      className="form-control form-control-solid border-gray-300 f-parrafo "
                      placeholder=""
                      id='local-sub'
                      value={remoteSubnet}
                      onChange={(e: any) => setremoteSubnet(e.target.value)}
                      maxLength={150}

                    />

                  </div>

                </div>




                <br />


                {currentUser?.is_demo !== true && <div className="d-flex justify-content-center">
                  <div className='row'>
                    <div className='col'>
                      {currentUser?.ListPermiso?.includes('Ctx.BGP.Add') && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && <button onClick={ADDSegment} type='submit' id='kt_sign_in_submit'
                      >{del ? 'Adding...' : 'Add'}{del && <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}</button>}

                      {currentUser?.ListPermiso?.includes('Ctx.BGP.Add') && Type === 'CloudGlobal' && <button onClick={ADDSegmentGlobal} type='submit' id='kt_sign_in_submit'
                      >{del ? 'Adding...' : 'Add'}{del && <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}</button>}
                      <button
                        className='btn-cancel btn text-pink border border-pink'
                        onClick={handleClose}
                        style={{ marginLeft: "10px", width: '200px' }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <br />

                </div>}

                {currentUser?.is_demo === true && <div className="d-flex justify-content-center">
                  <button onClick={() => setID(null)} type='submit' id='kt_sign_in_submit'
                  >{del ? 'Adding...' : 'Add'}</button>

                </div>}


              </div>
              {/*<div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cerrar</button>
                    </div>*/}
            </div>
          </div>
        </div>
        {showModal && <div className='modal-backdrop fade show'></div>}
        {ID !== undefined && <DemoModal setID={setID} id={ID} />}
      </div>
    </>
  );
};

export default Modal1;